import React, { FC, useEffect, useRef, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import CustomCalendarToolbar from './CustomCalendarToolbar';
import CustomCalendarHeader from './CustomCalendarHeader';

require('./EventCalendar.less');
require('../../../node_modules/react-big-calendar/lib/css/react-big-calendar.css');
require('../../../node_modules/react-big-calendar/lib/addons/dragAndDrop/styles.css');

// Set Monday as the first day of the week
moment.locale('en', {
	week: {
		dow: 1, // Monday
	},
});

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar) as any;

const EventCalendar: FC<any> = ({
	events,
	handleEventSelect,
	onSelectEvent,
	scrollToTime,
	...otherProps
}) => {
	const [currentTime, setCurrentTime] = useState(new Date());
	const containerRef = useRef<HTMLDivElement | null>(null);

	const ToolbarWithFetching = (props) => {
		return <CustomCalendarToolbar {...props} />;
	};

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentTime(new Date());
		}, 60000);

		return () => clearInterval(interval);
	}, []);

	// handling scrolltotime.
	useEffect(() => {
		if (!containerRef.current || !scrollToTime) {
			return;
		}

		const content = containerRef.current.querySelector('.rbc-time-content') as HTMLElement | null;

		if (!content) {
			return;
		}

		const minutesSinceMidnight = scrollToTime.getHours() * 60 + scrollToTime.getMinutes();
		const totalMinutesInDay = 24 * 60;
		const ratio = minutesSinceMidnight / totalMinutesInDay;

		const maxScroll = content.scrollHeight - content.clientHeight;
		content.scrollTop = maxScroll * ratio;
	}, [scrollToTime]);

	const eventPropGetter = (event) => {
		const baseClass = `calEventCategory--${event.category}`;
		const statusClass = event.eventStatus ? `calEventStatus--${event.eventStatus}` : '';
		return {
			className: `${baseClass} ${statusClass}`.trim(),
		};
	};

	return (
		<div className="eventCalendar__wrapper" style={{}} ref={containerRef}>
			<DnDCalendar
				localizer={localizer}
				{...otherProps}
				events={events}
				startAccessor="start"
				endAccessor="end"
				step={otherProps.step !== undefined ? otherProps.step : 60}
				eventPropGetter={eventPropGetter}
				showMultiDayTimes
				onSelectEvent={onSelectEvent}
				now={currentTime}
				popup={true}
				popupOffset={{ x: 10, y: 10 }}
				components={{
					toolbar: ToolbarWithFetching,
					header: CustomCalendarHeader,
					...otherProps.components,
				}}
				formats={{
					timeGutterFormat: (date, culture, localizer) => {
						return localizer.format(date, 'h:mm A', culture);
					},
					...otherProps.formats,
				}}
				timeslots={otherProps.timeslots !== undefined ? otherProps.timeslots : 1}
				draggableAccessor={otherProps.draggableAccessor}
				onEventDrop={otherProps.onEventDrop}
			/>
		</div>
	);
};

export default EventCalendar;
